import { render } from "./Bany.vue?vue&type=template&id=54430070&scoped=true"
import script from "./Bany.vue?vue&type=script&lang=js"
export * from "./Bany.vue?vue&type=script&lang=js"

import "./Bany.vue?vue&type=style&index=0&id=54430070&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54430070"]])

export default __exports__